import { createSelector } from '@reduxjs/toolkit';
export const facetRequestSelector = createSelector((state, facetId) => state.commerceFacetSet[facetId], (facet) => facet?.request);
